import { TextField } from '@mui/material';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

function TextInput({ name, value, onChange, ...props }) {
    const { register, resetField } = useFormContext();
    useEffect(() => resetField(name, { defaultValue: value }), [value]);

    return (
        <TextField
            fullWidth
            size="small"
            {...register(name)}
            {...props}
            onChange={onChange}
        />
    );
}

export default TextInput;
